import React from 'react';
import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import { StyledTextField } from './TextField.style';

export interface TextFieldProps extends Omit<MuiTextFieldProps, 'variant'> {
  /**
   * The variant of the text field
   */
  variant?: 'outlined' | 'filled' | 'standard';
  /**
   * Whether the field is required
   */
  required?: boolean;
  /**
   * Helper text to display below the input
   */
  helperText?: string;
  /**
   * Whether the field has an error
   */
  error?: boolean;
  /**
   * The size of the text field
   */
  size?: 'small' | 'medium';
  /**
   * Whether the field takes full width
   */
  fullWidth?: boolean;
  /**
   * Whether the field is disabled
   */
  disabled?: boolean;
}

export const TextField: React.FC<TextFieldProps> = ({
  variant = 'outlined',
  size = 'medium',
  fullWidth = false,
  ...props
}) => {
  return (
    <StyledTextField
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      {...props}
    />
  );
}; 